/** Загрузка FAQ с сайта через script (работает без CORS на nginx). */
export type FaqPayload = {
    updatedAt?: string;
    items?: Array<{
        q: string;
        a: string;
        'a-telegram'?: string;
        'a-max'?: string;
    }>;
};

declare global {
    interface Window {
        __BIZLAND_FAQ__?: FaqPayload;
    }
}

export function loadFaqFromSite(scriptUrl: string): Promise<FaqPayload> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = scriptUrl;
        script.onload = () => {
            const data = window.__BIZLAND_FAQ__;
            script.remove();
            if (!data?.items) {
                reject(new Error('FAQ empty'));
                return;
            }
            resolve(data);
        };
        script.onerror = () => {
            script.remove();
            reject(new Error('FAQ script failed'));
        };
        document.head.appendChild(script);
    });
}
